module.exports = __webpack_public_path__ + "img/v4.54c70e7.png";